import { useEffect, useState } from "react";
import "./theme.css";

const card = {
  border: "1px solid var(--audit-border)",
  borderRadius: 8,
  background: "var(--audit-bg-subtle)",
  padding: "12px 14px",
  marginBottom: 14,
};
const h3 = { fontSize: 14, fontWeight: 800, margin: "0 0 8px" };
const li = { fontSize: 13, lineHeight: 1.9 };
const pill = {
  fontSize: 12.5,
  padding: "5px 11px",
  border: "1px solid var(--audit-border)",
  borderRadius: 12,
  color: "var(--audit-accent)",
  textDecoration: "none",
};

function goTariff(e) {
  e.preventDefault();
  window.history.pushState({}, "", "/?audit=quickref&noextra=1");
  window.dispatchEvent(new PopStateEvent("popstate"));
}

export default function EndUseRatePage() {
  const [d, setD] = useState(null);

  useEffect(() => {
    fetch("/api/onto/enduse-rate")
      .then((r) => r.json())
      .then(setD)
      .catch(() => setD({}));
  }, []);

  const links = d?.links || {};

  return (
    <div
      className="audit-root"
      style={{
        height: "100%",
        overflow: "auto",
        background: "var(--audit-bg)",
        padding: "18px 22px",
      }}
    >
      <div style={{ maxWidth: 820 }}>
        <h2 style={{ fontSize: 17, fontWeight: 800, margin: "0 0 4px" }}>
          용도세율 · 사후관리 (관세법 제83조)
        </h2>
        <div
          style={{
            fontSize: 12.5,
            color: "var(--audit-text-muted)",
            marginBottom: 14,
          }}
        >
          같은 세번이라도 용도에 따라 세율이 다를 때, 낮은 세율(용도세율)을 적용받기 위한
          승인·사후관리 제도.
        </div>

        {d === null ? (
          <div style={{ fontSize: 13, color: "var(--audit-text-muted)" }}>
            불러오는 중…
          </div>
        ) : !d.requirements ? (
          <div style={{ fontSize: 13, color: "var(--audit-text-muted)" }}>
            데이터를 불러오지 못했습니다.
          </div>
        ) : (
          <>
            {/* 개요 */}
            <div style={{ ...card, background: "var(--audit-bg)" }}>
              <div style={h3}>개요</div>
              <div style={{ fontSize: 13, lineHeight: 1.75, color: "var(--audit-text)" }}>
                {d.overview}
              </div>
            </div>

            {/* 적용 요건 */}
            <div style={card}>
              <div style={h3}>적용 요건</div>
              <ul style={{ margin: 0, paddingLeft: 18 }}>
                {(d.requirements || []).map((c, i) => (
                  <li key={i} style={li}>
                    {c}
                  </li>
                ))}
              </ul>
            </div>

            {/* 사후관리 */}
            <div style={card}>
              <div style={h3}>사후관리 · 유의사항</div>
              <ul style={{ margin: 0, paddingLeft: 18 }}>
                {(d.postManagement || []).map((c, i) => (
                  <li key={i} style={li}>
                    {c}
                  </li>
                ))}
              </ul>
              <div
                style={{
                  fontSize: 11.5,
                  color: "var(--audit-text-faint)",
                  marginTop: 8,
                }}
              >
                ※ {d.note}
              </div>
            </div>

            {/* 근거·도구 */}
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 4 }}>
              {links.tariff && (
                <a
                  href="/?audit=quickref&noextra=1"
                  onClick={goTariff}
                  style={{ ...pill, borderColor: "var(--audit-accent)", fontWeight: 600 }}
                >
                  관세율표에서 용도별 세율 확인 →
                </a>
              )}
              {links.law && (
                <a href={links.law} target="_blank" rel="noreferrer" style={pill}>
                  law.go.kr — 관세법 제83조 ↗
                </a>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
